// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar-2Twaj","header_content":"header_content-V_rhL","info":"info-uZbX0","name":"name-YzaIK","edit":"edit-1iiju","empty":"empty-3i4Rv"};